import {UserForm} from "./form";

const CreateUser = () => {
   return <UserForm  />;
};

export default CreateUser;
